/* Shared storefront layout. No content, editor settings or media are changed. */
(()=>{
  const portals=[...document.querySelectorAll('.dc-origen')];
  if(!portals.length)return;
  let viewport=window;
  try{if(window.frameElement?.classList.contains('portal-live-preview'))viewport=window.parent;}catch{}
  function update(){
    const wide=viewport.matchMedia('(min-width:1024px), (min-width:600px) and (orientation:landscape)').matches&&window.innerWidth>=540;
    for(const portal of portals){
      portal.toggleAttribute('data-wide-layout',wide);
      portal.toggleAttribute('data-desktop-layout',wide&&window.innerWidth>=1000);
    }
  }
  update();
  window.addEventListener('resize',update,{passive:true});
  if(viewport!==window)viewport.addEventListener('resize',update,{passive:true});
  window.addEventListener('pagehide',()=>{if(viewport!==window)viewport.removeEventListener('resize',update);},{once:true});
})();
